<span [ngClass]="{ ok: okStatus, attention: attentionStatus, error: errorStatus }" translate>{{
  message.gungEdiMessageSendStatus | uppercase
}}</span>
